<template>
	<div class="feature">
		<div class="icon">
			<Icon :icon="icon" :color="color"/>
		</div>
		<div class="title">{{title}}</div>
		<div class="text" v-html="text"/>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon.vue";

export default {
	components: {Icon},

	props: {
		icon: {
			type: String,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
		text: {
			type: String,
			required: true,
		},
		color: {
			type: String,
			required: true,
		}
	}
}
</script>
